import { type MouseEvent as ReactMouseEvent } from 'react';
import { useIntl } from 'react-intl';

import { CopyIcon } from '@dynatrace/strato-icons';

import { Button } from '../../../buttons/button/Button.js';
import { Text } from '../../../typography/text/Text.js';
import { notificationMessages } from '../messages.js';

/**
 * The copy permissions button shown in the NotifyButton toast if the user doesn't have permissions to toggle notifications.
 * @internal
 */
export const CopyPermissionsButton = (
  props: Readonly<{ readOrWrite: 'read' | 'write' }>,
) => {
  const intl = useIntl();

  return (
    <Button
      variant="emphasized"
      onClick={async (e: ReactMouseEvent) => {
        e.stopPropagation();
        try {
          await navigator.clipboard.writeText(
            `notification:notifications:${props.readOrWrite}`,
          );
        } catch {
          // For now, we silently ignore clipboard write errors.
        }
      }}
    >
      <Button.Prefix>
        <CopyIcon />
      </Button.Prefix>
      <Text textStyle="base-emphasized">
        {intl.formatMessage(notificationMessages.copyMissingPermissions)}
      </Text>
    </Button>
  );
};
